"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResetPasswordSuccessSceneTranslation = {
    fi: {
        ResetPasswordSuccessScene: {
            title: 'Salasanasi on vaihdettu',
            toLogin: 'Kirjautumissivulle',
            subTitle: 'Salasanasi on vaihdettu onnistuneesti. Voit nyt palata kirjautumissivulle ja kirjautua uudella salasanalla',
        },
    },
    en: {
        ResetPasswordSuccessScene: {
            title: 'Your password is changed',
            toLogin: 'To login',
            subTitle: 'Your password is now changed. Go back to login page and log in with new password.',
        },
    },
};
exports.default = ResetPasswordSuccessSceneTranslation;
//# sourceMappingURL=ResetPasswordSuccessScene.translation.js.map